import { render, staticRenderFns } from "./ConveniosCotasNew.vue?vue&type=template&id=8a817720&scoped=true&"
import script from "./ConveniosCotasNew.vue?vue&type=script&lang=js&"
export * from "./ConveniosCotasNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a817720",
  null
  
)

export default component.exports